"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditRiskAssessmentReportDetails = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.CreditRiskAssessmentReportDetails = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.credit_risk_assessment_report_details.label',
    fallbackLabel: 'Please name your regulatory authority. Example: Swedish Financial Supervisory Authority (SFSA)',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_entity_answers.credit_risk_assessment_report_frequency', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.mor_entity_answers?.credit_risk_assessment_report_frequency?.valueOf?.() === 'MORE_ONCE_A_YEAR' || payload.mor_entity_answers?.credit_risk_assessment_report_frequency?.valueOf?.() === 'ANNUALLY' || payload.mor_entity_answers?.credit_risk_assessment_report_frequency?.valueOf?.() === 'MORE_THAN_ANNUALLY')
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.mor_entity_answers?.credit_risk_assessment_report_frequency?.valueOf?.() === 'MORE_ONCE_A_YEAR' || payload.mor_entity_answers?.credit_risk_assessment_report_frequency?.valueOf?.() === 'ANNUALLY' || payload.mor_entity_answers?.credit_risk_assessment_report_frequency?.valueOf?.() === 'MORE_THAN_ANNUALLY')
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
